// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xJfV","badges":"styles_badges__1bMwj"};